'use client';
import { useEffect, useState } from 'react';
/** Debounces `value` by `delayMs` (E6 §5.9: `q` debounced client-side ~250ms). */
export function useDebouncedValue(value, delayMs = 250) {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const timer = setTimeout(() => setDebounced(value), delayMs);
        return () => clearTimeout(timer);
    }, [value, delayMs]);
    return debounced;
}
